import React from 'react';
import { FormattedMessage } from 'react-intl';

import AccordionList from 'components/accordion-list';

import 'swiper/swiper.scss';
import './styles.scss';

const Faqs = [
  {
    title: 'partners.faqs.f1.title',
    description: 'partners.faqs.f1.description'
  },
  {
    title: 'partners.faqs.f2.title',
    description: 'partners.faqs.f2.description'
  },
  {
    title: 'partners.faqs.f3.title',
    description: 'partners.faqs.f3.description'
  },
  {
    title: 'partners.faqs.f4.title',
    description: 'partners.faqs.f4.description'
  }
];

const PartnersFaq = () => {
  const faqs = Faqs;

  return (
    <div className="partners-faq">
      <div className="container">
        <h6 className="partners-faq__title">
          <FormattedMessage id="partners.faqs.title" />
        </h6>
        <h1 className="h1--display partners-faq__description">
          <FormattedMessage id="partners.faqs.description" />
        </h1>
        <div className="row justify-content-center">
          <div className="col col-12 col-lg-8 col-xl-6">
            <AccordionList
              list={faqs}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnersFaq;
